// Modules
import { Action, createReducer, on } from '@ngrx/store';

// Interfaces
import { IDashboardAutoStatisticsResponse } from '@shared/interfaces';

// Actions
import * as DashboardActions from '@store/actions/dashboard.actions';

export interface DashboardAutoStatisticsState {
  dashboardAutoStatistics: IDashboardAutoStatisticsResponse;
  loading: boolean;
}

export const initialDashboardAutoStatisticsState: DashboardAutoStatisticsState =
  {
    dashboardAutoStatistics: null,
    loading: false,
  };

const DashboardAutoStatisticsReducer = createReducer(
  initialDashboardAutoStatisticsState,
  on(DashboardActions.reset, () => initialDashboardAutoStatisticsState),
  on(DashboardActions.getAutoStatisticsRequested, state => ({
    ...state,
    loading: true,
  })),
  on(DashboardActions.getAutoStatisticsResponse, (state, action) => ({
    ...state,
    dashboardAutoStatistics: action.payload,
    loading: false,
  }))
);

export function reducer(
  state: DashboardAutoStatisticsState | undefined,
  action: Action
): DashboardAutoStatisticsState {
  return DashboardAutoStatisticsReducer(state, action);
}
